import * as ng from 'angular';
import { AddIconBeforePlaceholder } from './add-icon-before-placeholder.directive';


export const AddIconBeforePlaceholderModule: string =
    ng.module('add-icon-before-placeholder', [
    ])
        .directive('addIconBeforePlaceholder', AddIconBeforePlaceholder)
        .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/add-icon-before-placeholder/add-icon-before-placeholder.module.ts